export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('academy_token') || ''}` });

export const letterColor = (letter) => {
  if (!letter) return '#52525b';
  const l = letter[0];
  if (l === 'A') return '#10b981';
  if (l === 'B') return '#84cc16';
  if (l === 'C') return '#f59e0b';
  if (l === 'D') return '#f97316';
  return '#ef4444';
};

export const fmtPct = (v) => (v === null || v === undefined ? '—' : `${Number(v).toFixed(1)}%`);
export const fmtGpa = (v) => (v === null || v === undefined ? '—' : Number(v).toFixed(2));
